import { useUserStore } from '@/stores/userStore';

/**
 * Whether the current (possibly impersonated) user has a DB-backed feature flag.
 *
 * Features are resolved server-side in featureFlagService (across USER / TEAM /
 * ORG grants) and ride on GET /api/me into the user store. Admins manage them
 * from the admin portal (/admin/features) — no code change or redeploy needed.
 *
 * `fallback` lets a feature keep its legacy gate during migration (e.g.
 * interactive-edu falls back to the 4K Labs team check) so access can never
 * regress if a grant is missing.
 */
export function useFeature(feature: string, fallback = false): boolean {
  const features = useUserStore((s) => s.features);
  return features.includes(feature) || fallback;
}
